import React from 'react';

const InputField = ({ label, id, name, value, onChange, error, className = "col-md-6" }) => {
    return (
        <div className={className}>
            <label htmlFor={id} className="form-label">
                {label}
            </label>
            <input
                type="time"
                className={`form-control ${error && error.length > 0 ? 'is-invalid' : ''}`}
                id={id}
                name={name}
                value={value || ''}
                onChange={onChange}
            />
            {error && error.length > 0 && (
                <div className="invalid-feedback">{error.join(', ')}</div>
            )}
        </div>
    );
};

export default InputField;
